import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {
    border,
    color,
    semanticColor,
    spacing,
} from "@khanacademy/wonder-blocks-tokens";
import {LabelXSmall} from "@khanacademy/wonder-blocks-typography";

import checkIcon from "@phosphor-icons/core/bold/check-bold.svg";
import editIcon from "@phosphor-icons/core/bold/pencil-simple-bold.svg";
import deleteIcon from "@phosphor-icons/core/bold/trash-bold.svg";

export const CorrectIcon = () => (
    <View style={[styles.letterIcon, styles.correctIcon]}>
        <PhosphorIcon color={color.offWhite} icon={checkIcon} size="small" />
    </View>
);
export const EditIcon = () => (
    <PhosphorIcon
        size="medium"
        color={semanticColor.core.foreground.neutral.strong}
        icon={editIcon}
    />
);
export const DeleteIcon = () => (
    <PhosphorIcon
        size="medium"
        color={semanticColor.core.foreground.neutral.strong}
        icon={deleteIcon}
    />
);

interface IncorrectIconProps {
    letter: string;
}

export const IncorrectIcon: React.FC<IncorrectIconProps> = (props) => (
    <View style={[styles.letterIcon, styles.incorrectIcon]}>
        <LabelXSmall style={styles.letterText}>{props.letter}</LabelXSmall>
    </View>
);

const styles = StyleSheet.create({
    letterIcon: {
        borderRadius: border.radius.radius_full,
        blockSize: spacing.large_24,
        inlineSize: spacing.large_24,
        minBlockSize: spacing.large_24,
        minInlineSize: spacing.large_24,
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        boxSizing: "border-box",
        borderStyle: "solid",
        borderWidth: border.width.medium,
    },
    incorrectIcon: {
        borderColor: semanticColor.core.border.neutral.default,
    },
    correctIcon: {
        backgroundColor: semanticColor.core.background.neutral.strong,
        borderColor: semanticColor.core.border.neutral.strong,
    },
    letterText: {
        color: semanticColor.core.border.neutral.default,
        fontWeight: "bold",
    },
});
